import { ChevronDownIcon, SparklesIcon } from "@heroicons/react/24/outline";
import { useAdBanner } from "../context/AdBannerContext";

const ReopenBannerButton: React.FC = () => {
  const { reopenBanner } = useAdBanner();

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-[40px] bg-gradient-to-r from-purple-600 to-pink-600">
      <button
        onClick={reopenBanner}
        className="w-full h-full px-4 flex items-center justify-center gap-2 text-white hover:bg-black/10 transition-colors cursor-pointer"
        aria-label="Mostra banner sponsorizzato"
      >
        <SparklesIcon className="h-4 w-4" />
        <span className="text-sm font-medium">Banner Sponsorizzato</span>
        <ChevronDownIcon className="h-4 w-4 animate-bounce" />
      </button>
    </div>
  );
};

export default ReopenBannerButton;
